import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { addAction } from '@/redux/store/information';
import UploadImg from '@/pages/components/uploadImg';
import alert from '@/pages/components/common/alert';
import ActionSheet from '@/pages/components/common/ui/actionsheet';

class addCustomer extends React.Component <{}, any>  {
	constructor(props: any) {
		super(props);
		this.state = {
			company_name: '',
			company_link: '',
			company_logo: ''
		}
	}
	render() {
		return (
			<div className="gray-bg">
				<ActionSheet />
				<div className="default-form">
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>企业名称</label>
						<input
							type="text" 
							placeholder="请输入企业名称" 
							className="text-right" 
							value={this.state.ce}  
							onChange={ (e:any) => this.changeState('company_name', e.target.value) }/>
						
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>企业链接</label>
						<input
							type="text" 
							placeholder="请输入企业链接" 
							className="text-right" 
							value={this.state.ce}  
							onChange={ (e:any) => this.changeState('company_link', e.target.value) }/>
						
					</div>
					<div className="form-upload-warrper">
						<label className="label">企业LOGO</label>
						<div className="form-upload">
							<UploadImg sucess={(data: any) => this.changeState('company_logo', data)}  id={this.state.company_logo} />
						</div>
					</div>
				</div>
				<div className="default-btn-warrper">
					<button className="default-btn" onClick={() => this.submitForm()}>确定</button>
				</div>
			</div>
		)
	}

	// 更新state
	private changeState(k: string, v: any) {
		this.setState({
			[k]: v
		})
	}

	// 更新state
	private changeInfoState(k:string, v:any) {
		(this.props as any).addAction({
			[k]: v
		})
	}

	private submitForm() {
		if(!this.state.company_name) {
			alert.open({
				promptText: '企业名称不能为空！'
			})
			return ;
		}
		if(!this.state.company_link) {
			alert.open({
				promptText: '企业链接不能为空！'
			})
			return ;
		}
		
		const obj = {
			company_name: this.state.company_name,
			company_link: this.state.company_link,
			company_logo: this.state.company_logo
		};
		let supplierArr = (this.props as any).supplier_data;
		supplierArr.push(obj)

		this.changeInfoState('supplier_data', supplierArr);
		this.goForm();
	}

	private goForm() {
		(this.props as any).history.goBack(-1)
	}
}


const mapStateToProps = ( state: any ) => {
    return {
        ...state.storeInformationReducer
    };
};

const mapDispatchToProps = ( dispatch: Dispatch ) => {
    return bindActionCreators({addAction }, dispatch);
};

export default connect( mapStateToProps, mapDispatchToProps )(addCustomer);